/**
 *  Slice a number to a specified number of decimal places.
 * @param {number} num - The number to be sliced.
 * @param {number} decimals - The number of decimal places to keep.
 * @returns {string} The number sliced to the specified decimal places.
 * @throws {Error} If the input is invalid
 * (num must be a number and decimals must be a non-negative number).
 */
const sliceToDecimals = (num, decimals) => {
  if (!num) {
    return 0;
  }
  if (typeof num !== 'number' || typeof decimals !== 'number' || decimals < 0) {
    throw new Error('Invalid input: num must be a number and decimals must be a non-negative number');
  }

  return num.toFixed(decimals);
};

/**
 * Round a floating-point number to the nearest integer.
 * @param {number} num - The floating-point number to be rounded.
 * @returns {number} The rounded integer.
 * @throws {Error} If the input is not a number.
 */
const roundNumber = (num) => {
  if (!num) {
    return 0;
  }
  if (typeof num !== 'number') {
    throw new Error('Invalid input: num must be a number');
  }

  return Math.round(num);
};

const removeNumberFormatting = (value) => {
  if (typeof value !== 'string') {
    throw new Error('Invalid input: value must be a string');
  }
  return parseFloat(value.replace(/[₪,\s]/g, ''));
};

export {
  sliceToDecimals,
  roundNumber,
  removeNumberFormatting,
};
